import { application } from "./application";

const applicationControllers = import.meta.glob("/controllers/**/*.js");
const carenDesignControllers = import.meta.glob("@caren_design/controllers/**/*.js");
const controllers = { ...applicationControllers, ...carenDesignControllers };
const loadedControllers = {};

function lazyLoadControllers(root = document) {
  root.querySelectorAll(`[data-controller]`).forEach(element => {
    element
      .getAttribute("data-controller")
      .split(/\s+/)
      .filter(content => content.length)
      .forEach(loadController);
  });
}

function loadController(name) {
  if (loadedControllers[name]) return;
  loadedControllers[name] = "pending";

  const filename = controllerFilename(name);
  const moduleFunc = controllers[filename];

  if (!moduleFunc) {
    // eslint-disable-next-line
    console.error(`Failed to autoload controller: ${name}`);
    return;
  }

  moduleFunc()
    .then(module => {
      loadedControllers[name] = "loaded";
      application.register(name, module.default);
    })
    .catch(error => {
      loadedControllers[name] = "errored";
      // eslint-disable-next-line
      console.error(`Failed to autoload controller: ${name}`, error);
    });
}

function controllerFilename(name) {
  const rootPath = name.startsWith("caren_design")
    ? "../../engines/caren_design/app/assets/javascripts/controllers"
    : "/controllers";

  return `${rootPath}/${name.replace(/--/g, "/").replace(/-/g, "_")}_controller.js`;
}

new MutationObserver(mutationsList => {
  for (const { target } of mutationsList) {
    lazyLoadControllers(target);
  }
}).observe(document, { attributeFilter: ["data-controller"], subtree: true, childList: true });

lazyLoadControllers();
